<template>
    <div>
        <a-skeleton :loading="loading" active >
            <a-list item-layout="vertical" size="small" :data-source="list">
                <a-list-item slot="renderItem" slot-scope="nest">
                    <a-list-item-meta>
                        <span slot="title" class="outerTitle">{{ nest.date }}</span>
                    </a-list-item-meta>
                    <a-list item-layout="vertical" size="small"
                        class="innerList" :data-source="nest.list"
                    >
                        <a-list-item slot="renderItem" key="item.id" slot-scope="item">
                            <a-list-item-meta>
                                <span slot="title">
                                    <b>#{{ item.id }}:</b> 发表在 <a class="towerLink" :href="`/games/${ item.name }`" target="_blank">{{ item.title }}</a> 于 <span class="timestr">{{ formatDate(item.timestamp) }} </span>
                                </span>
                            </a-list-item-meta>
                            <div class="comment">
                                <a :href="`/score.php?name=${ item.name }&num=10#${ item.id }`" target="_blank">
                                    <pre>{{ item.comment }}</pre>
                                </a>
                            </div>
                        </a-list-item>
                    </a-list>
                </a-list-item>
            </a-list>
            <a-pagination :current="Number($route.params.page)" :total="comment" 
                :defaultPageSize="20" @change="change" :hideOnSinglePage="true"
            />
        </a-skeleton>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from '../../../plugins/axios';
const Memo = {};

export default {
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.load(to.params.page);
        });
    },
    async beforeRouteUpdate(to, from, next) {
        await this.load(to.params.page);
        next();
    },
    data: () => ({
        data: [],
        loading: false,
    }),
    computed: {
        ...mapState('$user', [ 'userid', 'comment' ]),
        list() {
            const nestedList = [];
            for (let record of this.data) {
                let len = nestedList.length;
                const date = new Date(record.timestamp * 1000).toLocaleDateString();
                if (len == 0 || date != nestedList[len-1].date) {
                    nestedList.push({
                        title: record.title, date, list: []
                    })
                    len++;
                }
                nestedList[len-1].list.push(record);
            }
            return nestedList;
        }
    },
    methods: {
        async load(key) {
            if (!Memo[key]) {
                this.loading = true;
                const { data } = await axios.get(`/backend/user/detail.php`, {
                    params: {
                        id: this.userid, type: "comment", page: key
                    }
                });
                Memo[data.page] = data.comment;
                this.loading = false;
            }
            this.data = Memo[key];
        },
        change(page) {
            this.$router.push({ name: 'comment', params: { page } });
        },
        formatDate(timestamp) {
            return (new Date(timestamp * 1000)).toLocaleString("cn-ZH", { hour12: false });
        }
    }
}
</script>

<style lang="less" scoped>
.ant-list-vertical .ant-list-item-meta {
    margin: 0;
}
.outerTitle, .towerLink {
    font-weight: 700;
}
.innerList {
    margin-left: 25px;
    .timestr {
        color: gray;
    }
}
.comment {
    margin-left: 10px;
    padding: 10px;
    background-color: #EEEEEE;
    a {
        color: inherit;
    }
    pre {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        margin: 0;
    }
}
</style>